module.exports = __webpack_public_path__ + "img/cuff_length.237b7f1a.png";